import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  setGoogleApiAccessToken,
  setApiBaseURL,
  setApiVersion,
  setAppVersion,
  setBundleId,
  setAppleAppId,
  setXBrandId,
  setTurnstileSiteKey,
} from '../redux/store/config';
import { setPhoneCode } from '../redux/store/ui/firstSteps';
import { setShowHomeWT } from '../redux/store/ui/map';

export type Props = {
  setGoogleApiAccessToken: typeof setGoogleApiAccessToken;
  setApiBaseURL: typeof setApiBaseURL;
  setApiVersion: typeof setApiVersion;
  setAppVersion: typeof setAppVersion;
  setBundleId: typeof setBundleId;
  setAppleAppId: typeof setAppleAppId;
  setXBrandId: typeof setXBrandId;
  setTurnstileSiteKey: typeof setTurnstileSiteKey;
  setPhoneCode: typeof setPhoneCode;
  setShowHomeWT: typeof setShowHomeWT;
};

const withConfigSetter: any = compose(
  connect(null, {
    setGoogleApiAccessToken,
    setApiBaseURL,
    setApiVersion,
    setAppVersion,
    setBundleId,
    setAppleAppId,
    setXBrandId,
    setTurnstileSiteKey,
    setPhoneCode,
    setShowHomeWT,
  })
);
export default withConfigSetter;
